import axios from 'axios';
import config from './config';

// 1. Create Axios Instance
const api = axios.create({
  baseURL: config.API_BASE_URL,
});

// 2. The "Magic" Interceptor (Ye code missing tha)
// Ye har request ke sath Token automatically jod dega
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token'); // Browser se token nikalo
    if (token) {
      config.headers.Authorization = `Bearer ${token}`; // Header me chipka do
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export default api;